import { useContext, useState } from "react";
import { DoneIconCircled } from "../../../Icons/Icons";
import "./welcomeFirstLogin.sass";
import { useIntl } from "react-intl";
import { firstLoginTranslate } from "../../../i18n/translatedMessages";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { EmployerContext } from "../../../Store/EmployerContext";
import { MdOutlineGTranslate, MdOutlineTranslate } from "react-icons/md";

const cards_es = ["Acceso a tu portal de carrera", "Acceso a nuestro Feed y Red Social", "Reporte Salarial Hecho a Medida", "Outplacement Digital Gratis por 3 dias"];

const cards_ptbr = ["Acesso ao seu portal de carreira", "Acesso ao nosso Feed e Rede Social", "Relatório Salarial Personalizado", "Outplacement Digital Gratuito por 3 dias"];

const WelcomeFirstLogin = ({ onNextStep }) => {
  const { actions, store } = useContext(EmployerContext);
  const [value, setValue] = useState(store.language === "ES" ? "Español" : "Português");
  const language = useIntl().locale;
  const cards = language === "PT-BR" ? cards_ptbr : cards_es;
  const handleStartClick = () => {
    onNextStep();
  };

  const handleSelect = (e) => {
    setValue(e);
  };

  return (
    <>
      <div className="mb-5">
        <DropdownButton
          className="custom-dropdown-first rounded-pill"
          size="sm"
          title={
            <>
              <MdOutlineTranslate style={{ marginRight: "8px" }} />
              {value}
            </>
          }
          onSelect={handleSelect}
          style={{ color: "red" }}
        >
          <Dropdown.Item eventKey="Español" onClick={() => actions.setLanguage("ES")}>
            Español
          </Dropdown.Item>
          <Dropdown.Item eventKey="Português" onClick={() => actions.setLanguage("PT-BR")}>
            Português
          </Dropdown.Item>
        </DropdownButton>
      </div>
      <div className="d-flex">
        <div className="col-md-6 me-5 text-white">
          <h2>
            <strong>{firstLoginTranslate.welcomePageTitle}</strong>
          </h2>
          <div className="mt-5 mb-3 text-gray">{firstLoginTranslate.welcomePageText}</div>
          <div className="text-gray">{firstLoginTranslate.welcomePageText2}</div>
          <button className="custom-btn mt-5" onClick={handleStartClick}>
            {firstLoginTranslate.welcomePageBtn}
          </button>
        </div>
        <div className="col-md-6 text-gray">
          <div className="mb-3">{firstLoginTranslate.welcomePageText4}</div>
          <div>
            {cards.map((item) => (
              <div className="card-gradient my-3 p-3 d-flex">
                <div className="me-2 d-flex align-items-center">
                  <DoneIconCircled size={20} />
                </div>
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default WelcomeFirstLogin;
